import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  Modal,
  Picker,
} from "react-native";
import { typeConnect } from "../../constants/Constants";
import { styles } from "../../style/FoundryStyle";
import { getCurrentDateTime } from "../../services/Functions";
import { useSelector } from "react-redux";
import {
  getListProblemSolution,
  InserNewQualityMultiwork,
} from "../../services/ConnectDataBase.js";
import ImageDetailsComponent from "../Info/ComponentDetalles";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { STATUS_COLORS, TEXT_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

export default function OptionsCalidad({ mo, currentScreenId }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalCorrectoVisible, setModalCorrectoVisible] = useState(false);
  const [descripcionIncidencia, setDescripcionIncidencia] = useState(false);
  const [cantidadIncidencia, setCantidadIncidencia] = useState(0);
  const [calidadFinalizado, setCalidadFinalizado] = useState(false);
  const placeHolderIncidiencias = "Cantidad con incidencia";
  const [listaProblemasSoluciones, setListaProblemasSoluciones] = useState([]);
  const [cantidad, setCantidad] = useState(parseFloat(mo.cantidad).toFixed(1));
  const name = useSelector((state) => state.user.name);
  const team = useSelector((state) => state.user.team);
  const cod_team = useSelector((state) => state.user.cod_team);
  const tipo_tiempo = "TIME_WORK";
  const tipo = "CALIDAD";
  const codigo = "121";
  const [opcionSeleccionada, setOpcionSeleccionada] = useState("");
  const [codigoIncidencia, setCodigoIncidencia] = useState(null);
  const [codigoSolucion, setCodigoSolucion] = useState(null);
  const [conOsinIncidencia, setConOsinIncidencia] = useState(false);
  const piezasToWork =
    parseFloat(mo.cantidad).toFixed(1) -
    parseFloat(mo.cantidad_terminada).toFixed(1);

  const handleTime = async () => {
    await InserNewQualityMultiwork(
      "CALIDADCONERRORES",
      mo.po,
      mo.mo,
      name,
      team,
      codigoIncidencia,
      codigoSolucion,
      descripcionIncidencia,
      tipo_tiempo,
      mo.cantidad,
      cantidad,
      cantidadIncidencia,
      typeConnect[1],
      currentScreenId,
      cod_team,
      codigo,
      getCurrentDateTime()
    );

    setConOsinIncidencia(true);
    setCalidadFinalizado(true);
  };

  const handleTimeCorrect = async () => {
    await InserNewQualityMultiwork(
      "CALIDADCORRECTA",
      mo.po,
      mo.mo,
      name,
      team,
      codigoIncidencia,
      codigoSolucion,
      tipo,
      tipo_tiempo,
      mo.cantidad,
      cantidad,
      cantidadIncidencia,
      typeConnect[1],
      currentScreenId,
      cod_team,
      codigo,
      getCurrentDateTime()
    );
    setCalidadFinalizado(true);
    setConOsinIncidencia(false);
  };

  const handleAceptar = async () => {
    if (codigoIncidencia && parseFloat(cantidad).toFixed(1) > 0) {
      handleTime();
      setModalVisible(false);
    } else {
      return;
    }
  };

  const buttonCorrect = async () => {
    if (parseFloat(cantidad).toFixed(1) > 0 && cantidad <= piezasToWork) {
      handleTimeCorrect();
      setModalCorrectoVisible(false);
    } else {
      return;
    }
  };

  const handleIncidencia = () => {
    getListOptionsProblemQuality(mo.mo);
    setModalVisible(true);
  };

  const handleCantidadIncidenciaChange = (text) => {
    const cantidadIncidenciaFloat = parseFloat(text, 10);
    if (cantidadIncidenciaFloat > cantidad) {
      notify.warn(
        "La cantidad de piezas con incidencia no puede ser mayor a la cantidad"
      );
    } else {
      setCantidadIncidencia(cantidadIncidenciaFloat);
    }
  };
  const handleCorrecto = () => {
    setModalCorrectoVisible(true);
  };

  const handleCancelar = () => {
    setModalVisible(false);
    setModalCorrectoVisible(false);
  };

  const handleCantidadChange = (text) => {
    if (piezasToWork < parseFloat(text).toFixed(1)) {
      notify.warn("La cantidad no puede superar el numero de piezas por terminar");
      return;
    }
    setCantidad(text);
  };

  async function getListOptionsProblemQuality(mo) {
    try {
      const options = await getListProblemSolution(mo, 5, cod_team, "list");

      setListaProblemasSoluciones(options);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <View>
      {mo.cantidad_terminada === mo.cantidad ? (
        <MaterialCommunityIcons
          name='checkbox-multiple-outline'
          size={24}
          color='lightgreen'
        />
      ) : calidadFinalizado ? (
        conOsinIncidencia ? (
          <MaterialCommunityIcons name='alert-circle' size={24} color='red' />
        ) : (
          <MaterialCommunityIcons
            name='check-all'
            size={24}
            color='lightgreen'
          />
        )
      ) : (
        <View style={styles.row}>
          <ImageDetailsComponent imageUrl={mo.imgcalidad} mo={mo} />
          <TouchableOpacity onPress={handleCorrecto}>
            <Text
              style={[
                styles.buttonAddWeight,
                {
                  fontSize: 16,
                  height: 40,
                  backgroundColor: STATUS_COLORS.SUCCESS,
                  color: TEXT_COLORS.LIGHT,
                  margin: 5,
                },
              ]}>
              Correcto
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={handleIncidencia}>
            <Text
              style={[
                styles.buttonAddWeight,
                {
                  fontSize: 16,
                  height: 40,
                  backgroundColor: STATUS_COLORS.ERROR,
                  color: TEXT_COLORS.LIGHT,
                  margin: 5,
                },
              ]}>
              Incidencia
            </Text>
          </TouchableOpacity>
        </View>
      )}

      <Modal visible={modalVisible} animationType='fade' transparent>
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Confirmar</Text>
            <TextInput
              style={[styles.pickerItemStyle, { backgroundColor: "white" }]}
              placeholder={placeHolderIncidiencias}
              placeholderTextColor='rgba(0, 0, 0, 0.4)'
              keyboardType='decimal-pad'
              value={cantidad.toString() || ""}
              onChangeText={handleCantidadChange}
            />
            <TextInput
              style={[styles.pickerItemStyle, { backgroundColor: "white" }]}
              placeholder={placeHolderIncidiencias}
              placeholderTextColor='rgba(0, 0, 0, 0.4)'
              keyboardType='numeric'
              value={cantidadIncidencia || ""}
              onChangeText={handleCantidadIncidenciaChange}
            />
            <Picker
              style={styles.pickerItemStyle}
              selectedValue={opcionSeleccionada}
              onValueChange={(itemValue) => {
                if (itemValue === null) {
                } else {
                  setOpcionSeleccionada(itemValue);

                  const selectedOption = listaProblemasSoluciones.find(
                    (option) => option.incidencia === itemValue
                  );

                  if (selectedOption) {
                    setCodigoIncidencia(selectedOption.incidencia);
                    setCodigoSolucion(selectedOption.solucion);
                    setDescripcionIncidencia(selectedOption.descind);
                  }
                }
              }}>
              <Picker.Item label='Seleccionar opción' value={null} />{" "}
              {listaProblemasSoluciones.map((option, index) => (
                <Picker.Item
                  key={option.incidencia}
                  label={option.descind + " - " + option.descsol}
                  value={option.incidencia}
                />
              ))}
            </Picker>

            <View style={styles.buttonModalContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonAccept]}
                onPress={handleAceptar}>
                <Text style={styles.modalText}>Aceptar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonCancel]}
                onPress={handleCancelar}>
                <Text style={styles.modalText}>Cancelar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Modal visible={modalCorrectoVisible} animationType='fade' transparent>
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Confirmar</Text>
            <TextInput
              style={[styles.pickerItemStyle, { backgroundColor: "white" }]}
              placeholder={placeHolderIncidiencias}
              placeholderTextColor='rgba(0, 0, 0, 0.4)'
              keyboardType='decimal-pad'
              value={cantidad.toString() || ""}
              onChangeText={handleCantidadChange}
            />
            <View style={styles.buttonModalContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonAccept]}
                onPress={buttonCorrect}>
                <Text style={styles.modalText}>Aceptar</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.modalButtonCancel]}
                onPress={handleCancelar}>
                <Text style={styles.modalText}>Cancelar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}
